<template>
  <div class="export-fail">
    <div class="export-fail-content">
      <!-- <div class="export-fail-content-header">
        <h3>导入结果</h3>
        <ds-iconfont
          class="close"
          icon-class="icon-ds-guanbi1"
          @click.native="close"
        />
      </div> -->
      <div class="export-fail-content-con">
        <ds-iconfont
          class="icon"
          icon-class="icon-ds-cuowutishi"
        />
        <span>导入失败</span>
      </div>
      <div class="tips">
        失败原因：{{ errorMsg }}
      </div>
      <div class="handle">
        <mk-button-biz
          width="56px"
          height="32px"
          @click="close"
        >
          关闭
        </mk-button-biz>
        <mk-button-biz
          type="primary"
          width="84px"
          height="32px"
          @click="continueClick"
        >
          重新导入
        </mk-button-biz>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    errorMsg: {
      type: String,
      default: '发现异常情况，请重新上传'
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    continueClick () {
      this.$emit('continue')
    }
  }
}
</script>
<style lang="scss" scoped>
  .export-fail {
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.32);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;

    .export-fail-content {
      width: 400px;
      border-radius: 4px;
      background-color: #fff;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      .export-fail-content-header {
        width: 100%;
        height: 54px;
        box-sizing: border-box;
        border-bottom: 1px solid #e8e8e8;
        display: flex;
        align-items: center;
        justify-content: space-between;

        h3 {
          font-size: 14px;
          color: #262626;
          margin-left: 20px;
        }

        .close {
          font-size: 14px;
          color: #bfbfbf;
          margin-right: 20px;
          cursor: pointer;
        }
      }

      .export-fail-content-con {
        display: flex;
        align-items: center;
        margin: 20px 20px 10px 20px;

        .icon {
          color: #f5222d;
          font-size: 24px;
        }

        span {
          font-size: 16px;
          font-weight: 500;
          margin-left: 16px;
        }
      }

      .tips {
        width: calc(100% - 76px);
        margin: 0 0 30px 56px;
        color: #595959;
        font-size: 13px;
        line-height: 24px;
      }

      .handle {
        display: flex;
        justify-content: flex-end;
        margin: 0 15px 15px 0;

        /deep/ .el-button {
          font-size: 13px;
        }
      }
    }
  }
</style>
